<script setup lang="ts">
import { useCompanyStore } from '@Stores/company.store';
import { useLocationStore } from '@Stores/location.store';
import { ShowcaseLayout, SupportEmailLink } from '@Shared';
import useCompanyImageBaseUrl from '@Src/use/useCompanyImageBaseUrl';
import ShowcaseImage from '@Components/ShowcaseImage.vue';

const companyStore = useCompanyStore();
const locationStore = useLocationStore();
const companyImageBaseUrl = useCompanyImageBaseUrl();
</script>

<template>
    <showcase-layout
        title="We've paused your request"
        :company="companyStore.company"
        :brand="companyStore.brand"
        :location="locationStore.location"
        :company-image-base-url="companyImageBaseUrl"
        show-powered-by>

        <template #mobileAccent>
            <div class="request-paused-candy">
                <img
                    class="request-paused-candy__image"
                    :src="'/images/cancelled.svg'"
                    alt=""
                />
            </div>
        </template>

        <template #branded>
            <showcase-image />
        </template>

        <app-form-content-layout>
            <div class="request-paused-content">
                <p>
                    Something about this request didn't look right. We've paused it to keep your information safe.
                    <br />
                    <br />
                    You will receive a notification from our team when you can proceed forward.
                    <br />
                    <br />
                    Your closing team has been notified.
                    <br />
                    <br />
                    If you have any questions please reach out to
                    <support-email-link />
                </p>
            </div>
        </app-form-content-layout>
    </showcase-layout>
</template>

<style lang="scss" scoped>
@use 'certifid-v2-client-hub-styles' as *;

.request-paused-candy {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;

    &__image {
        max-width: 11.6875rem;
        max-height: 11rem;

        @include desktop {
            width: 25rem;
            max-width: none;
            max-height: 21.6875rem;
        }
    }
}

.request-paused-content {
    line-height: 1.5;
}

:deep(.showcase-layout__mobile-accent) {
    @include tablet-and-down {
        margin-top: 4.38rem !important;
    }
}

</style>
